import { useState } from "react";

import Joyride, { ACTIONS, EVENTS, STATUS, CallBackProps } from "react-joyride";
import { ClientOnly } from "remix-utils/client-only";

type Step = {
  disableBeacon: boolean;
  target: string;
  content: string;
};

function Tour({
  steps,
  run,
  stepIndex,
  setRun,
  setStepIndex,
}: {
  steps: Step[];
  run: boolean;
  stepIndex: number;
  setRun: (run: boolean) => void;
  setStepIndex: (stepIndex: number) => void;
}) {
  const handleJoyrideCallback = (data: CallBackProps) => {
    const { action, index, status, type } = data;

    if (action === ACTIONS.CLOSE) {
      setRun(false);
    }

    if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type as any)) {
      setStepIndex(index + (action === ACTIONS.PREV ? -1 : 1));
    } else if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status as any)) {
      setRun(false);
    }
  };

  return (
    <Joyride
      steps={steps}
      stepIndex={stepIndex}
      run={run}
      showSkipButton
      callback={handleJoyrideCallback}
      continuous={true}
      styles={{ options: { zIndex: 1000 } }}
    />
  );
}

export function useTour(steps: Step[]) {
  const [run, setRun] = useState(false);
  const [stepIndex, setStepIndex] = useState(0);

  const tour = (
    <ClientOnly>
      {() => (
        <Tour
          steps={steps}
          run={run}
          stepIndex={stepIndex}
          setRun={setRun}
          setStepIndex={setStepIndex}
        />
      )}
    </ClientOnly>
  );

  const restart = () => {
    setRun(true);
    setStepIndex(0);
  };

  return { tour, restart };
}
